import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const KeywordPositioningPage = lazyWithRetry(() => import('./pages/KeywordPositioningPage'))
const KeywordPositionListPage = lazyWithRetry(() => import('./pages/KeywordPositionListPage'))

const routes: AppRoute[] = [
  {
    path: 'keyword-positioning',
    meta: {
      title: 'sidebarNav.keywordPositioning',
      require: { minRole: ROLE.MEMBER },
    },
    children: [
      {
        index: true,
        element: KeywordPositioningPage,
      },
      {
        path: ':id',
        element: KeywordPositionListPage,
      },
    ],
  },
]

export default routes
